var downloads = new function () {
    this.setDownloadCount = function (el) {
        var $wrapper = $(el),
            data = {
                action: 'rnr_set_download_count',
                id: $wrapper.data('id'),
                media: $wrapper.data('media'),
                helpful: $(el).data('type'),
                _wpnonce: $wrapper.data('nonce')
            };
        if (typeof this.xhr == 'object') this.xhr.abort();
        this.xhr = jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: data,
            success: function (json) {
                console.log(json);
            }
        });
    };
};

$(document).ready(function() {

    $(document).on('click', '.downloads__link', function(e) {
        downloads.setDownloadCount($(this));
    });

});